import { Box } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';

const HeadSkeleton = () => {
  return (
    <Box mb="32px">
      <SkeletonComponent height="32px" width="300px" mb="8px" />
      <SkeletonComponent height="17px" width="250px" />
    </Box>
  );
};

export default HeadSkeleton;
